import React from 'react';
import { Stack } from '../../../../atoms/stack/Stack';
import { Radio } from '../../../../atoms/radio/Radio';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { useEffect } from 'react';
import { Row } from '../../../../atoms/row/Row';
import { Typography } from '../../../../atoms/typography/Typography';

const TextQuestion = ({ question, currentStep }) => {
  const { register, setValue, watch } = useFormContext();
  const [radioValue, setRadioValue] = useState(false);
  let text = watch(`question-${question.id}`);

  const onRadioChange = () => {
    setRadioValue(true);
    setValue(`question-${question.id}`, '');
    setValue(`question-${question.id}-checked`, true);
  };

  useEffect(() => {
    if (text && text.length > 0) {
      setRadioValue(false);
    }
  }, [text]);

  return (
    <Stack className={`w-full gap-3`}>
      <input
        id="search_systems"
        className="w-full font-ubuntu text-clamp-md h-16 border border-customGray-300 rounded-lg px-6 placeholder:text-customGray-500 placeholder:text-clamp-md placeholder:font-light focus:outline-none"
        placeholder="Skriv här vilket system ni använder idag"
        {...register(`question-${question.id}`)}
      />
      <Row onClick={onRadioChange} className={`w-full py-3 pl-4 pr-6 bg-[#EAF5FB] rounded-3xl gap-3 global-hover`}>
        <Radio
          checked={radioValue}
          name={`question_${currentStep}`}
          onChange={onRadioChange}
        />
        <Typography
          fontVariant={'md'}
          textAlign={'left'}
          className={'text-customGray-700'}
        >
          Vet ej
        </Typography>
      </Row>
    </Stack>
  );
};

export default TextQuestion;
